import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";

const RuntimeSecuritySkeleton = () => (
  <Box direction="column">
    <Skeleton height={294} width="100%" borderRadius={12} />
  </Box>
);

export default RuntimeSecuritySkeleton;
